import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const SelectPaletteToolTip = (props) => (
  <div>
    Predefined color schemes for repeat clients.
  </div>
);

export const PageBkgdToolTip = (props) => (
  <div>
    A solid color behind the background image(s). Will be only background on tablet and mobile.
  </div>
);

export const BrandThemeColorToolTip = (props) => (
  <div>
   Text color on the break that will affect-
   <br/>
   <ul>
     <li>Landing page color bar over the image</li>
     <li>Color bar on “Up Next” images</li>
     <li>Headline bar</li>
     <li>Result bar in Personality Quiz & Trivia</li>
     <li>Buttons in Personality Quiz & Trivia</li>
   </ul>
   <br/>
   <img src={makeToolTipUrl('break/colors/17.CMS-Brand-theme-color.png')} width="100%"/>
  </div>
);

export const BrandThemeTextToolTip = (props) => (
  <div>
    Text color on the break that will affect-
    <br/>
    <ul>
      <li>Landing page color bar over the image?</li>
      <li>Color bar on “Up Next” images</li>
      <li>Headline bar</li>
      <li>Result bar in Personality Quiz & Trivia</li>
      <li>Buttons in Personality Quiz & Trivia</li>
    </ul>
  </div>
);

export const ButtonColorToolTip = (props) => (
  <div>
   Color on the primary button within all steps.
   <br/>
   <img src={makeToolTipUrl('break/colors/18.CMS-Button-color.png')} width="100%"/>
  </div>
);

export const LockedOverlayColorToolTip = (props) => (
  <div>
    Color that overlays images, typically is #000000 (black) and affects -
    <br/>
    <ul>
      <li>Landing page tiles when locked or completed</li>
      <li>Tiles when locked or completed on “Up Next” progress bar</li>
      <li>Personality Quiz Images</li>
      <li>Trivia Quiz images</li>
    </ul>
  </div>
);

export const ReplayTextColorToolTip = (props) => (
  <div>
    Color of “replay” text on completed break tiles on the landing page.
  </div>
);

export const ReplayTextBkgdColorToolTip = (props) => (
  <div>
    Color of the result text box on Personality Quiz, Lead Gen, Trivia, Referral & Memory Match. Recommend #e6e6e6.
    <br/>
    <img src={makeToolTipUrl('break/colors/19.CMS-Result-page-text-bgrd-color.png')} width="100%"/>
  </div>
);

export const ProgressBarBkgdColorToolTip = (props) => (
  <div>
    Active color on personality quiz, trivia, and poll progress bar within the step.
    <br/>
    <img src={makeToolTipUrl('break/colors/20.CMS-Progress-bar-landing-bkgd-color.png')} width="100%"/>
  </div>
);

export const ProgressBarTextColorToolTip = (props) => (
  <div>
    Color of the text on personality quiz, trivia, and poll progress bar within the step.
  </div>
);

export const ProgressBarSuccessBkgdColorToolTip = (props) => (
  <div>
    Color of correct answer on Trivia progress bar, completed item in personality quiz and poll progress bar, and poll results graph.
    <br/>
    <img src={makeToolTipUrl('break/colors/21.CMS-Progress-bar-success-bkgd-color.png')} width="100%"/>
  </div>
);

export const ProgressBarFailBkgdColorToolTip = (props) => (
  <div>
    Color of wrong answer on trivia and poll progress bar & poll results graph.
    <br/>
    <img src={makeToolTipUrl('break/colors/22.CMS-Progress-bar-fail-bkgd-color.png')} width="100%"/>
  </div>
);

export const LandingHeadlineColorToolTip = (props) => (
  <div>
    Color of the headline text on a break landing page. Default is #000000(black).
    <br/>
    <img src={makeToolTipUrl('break/general/2.CMS-Break-title-headline.png')} width="100%"/>
  </div>
);

export const MobileLandingHeadlineColorToolTip = (props) => (
  <div>
    Color of the headline text on a break landing page on mobile/tablet device. Default is #000000(black).
    <br/>
    <img src={makeToolTipUrl('break/colors/23.CMS-Mobile-landing-page-headline.png')} width="100%"/>
  </div>
);

export const LandingIntroCopyColorToolTip = (props) => (
  <div>
    Color of intro copy on landing page.
    <br/>
    <img src={makeToolTipUrl('break/general/7.CMS-landing-page-intro-copy.png')} width="100%"/>
  </div>
);

export const MobileLandingIntroCopyColorToolTip = (props) => (
  <div>
    Color off intro copy on mobile landing page.
    <br/>
    <img src={makeToolTipUrl('break/general/8.CMS-landing-page-intro-mobile.png')} width="100%"/>
  </div>
);

export const LegalTextColorToolTip = (props) => (
  <div>
    Color of the legal copy on landing page. Affects ALL legal copy on lead gen, complete, receipt verification, and UGC.
    <br/>
    <img src={makeToolTipUrl('break/colors/24.CMS-Legal-T&C-text-color.png')} width="100%"/>
  </div>
);

export const SponsorNameColorToolTip = (props) => (
  <div>
    Color of the “sponsor name” on landing page of sponsored breaks.
    <br/>
    <img src={makeToolTipUrl('break/general/10.CMS-Sponsor-name.png')} width="100%"/>
  </div>
);

export const LearnMoreHeadlineColorToolTip = (props) => (
  <div>
    Extra real estate to call out products or prizing on landing page of sponsored breaks.
    <br/>
    <img src={makeToolTipUrl('break/general/25.CMS-Learn-more-modal-after-landing-page.png')} width="100%"/>
    <br/>
    <img src={makeToolTipUrl('break/general/26.CMS-Learn-more-modal-after-landing-page.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/breaks-color-section-tool-tips.jsx